export const profile = {
  title: "Profile",
  info: {
    title: "User Information",
    email: "Email",
    firstName: "First Name",
    lastName: "Last Name",
    cpf: "CPF",
    update: "Update Profile",
    birthday: "Birthday",
  },
  password: {
    title: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    update: "Update Password",
    success: "Password updated successfully",
    error: "Failed to update password",
    mismatch: "The new passwords do not match",
    tooShort: "The password must be at least 8 characters long",
    setTitle: "Update password",
  },
  update: {
    success: "Profile updated successfully",
    error: "Failed to update profile",
  },
  affiliate: {
    title: "Affiliate Program",
    cardDescription:
      "Our affiliate program is simple, for each payment made by an indication of yours, you will receive a commission in credits according to your level.",
    cardDescription2:
      "The affiliate system is subject to adjustments and changes, according to our affiliate policies.",
    tiers: {
      level: "Level",
      requirement: "Requirement",
      commission: "Commission",
      standard: "Standard",
      standardReq: "Up to $100 in total indications",
      silver: "Silver",
      silverReq: "$100 to $500 in total indications",
      gold: "Gold",
      goldReq: "Above $500 in total indications",
    },
    yourId: "Your Affiliate ID:",
    copy: "Copy ID",
    copied: "Copied to clipboard!",
    link: "Your Affiliate Link:",
    copyLink: "Copy Link",
    linkCopied: "Link copied to clipboard!",
    join: "Become an Affiliate",
    success: "You are now an affiliate!",
    error: "Failed to become an affiliate",
    earnings: {
      title: "Your Earnings",
      total: "Total Earnings",
      pending: "Pending Earnings",
      referrals: "Total Referrals",
      recentEarnings: "Recent Earnings",
      noEarnings: "No earnings yet",
      source: "Source",
      amount: "Amount",
      status: "Status",
      date: "Date",
    },
  },
};
